export const UPDATE_DOCUMENT_REQUEST = 'UPDATE_DOCUMENT_REQUEST';

export const updateDocumentRequest = ( id, formData ) => ({
    type: UPDATE_DOCUMENT_REQUEST,
    payload: { id, formData }
});
